<template>
    <div class="jdfw">
      <img src="../../assets/img/jdfwphone.png" style="width: 100%;margin-top: 4%"/>
      <div style="width: 630px;margin: auto">
        <h3 style="color: #ffffff;font-size: 30px;letter-spacing:8px">我要留言:</h3>
        <div style="    border: 1px #ffffff solid;
    padding: 10px;
    background: #00000033; box-shadow: -2px 2px 1px 0px #555555 ;">
          <el-form :model="lyFrom" :rules="rules" ref="lyFrom" label-width="100px" class="demo-lyFrom">
            <el-row>
             <el-col :span="14">  <el-form-item label="联系人" prop="contactsName">
    <el-input v-model="lyFrom.contactsName"></el-input>
  </el-form-item></el-col>
            </el-row>

            <el-row>
              <el-col :span="12">  <el-form-item label="联系电话" prop="contactsMobile">
    <el-input v-model="lyFrom.contactsMobile"></el-input>
  </el-form-item></el-col>
             <el-col :span="12">  <el-form-item label="联系邮箱" prop="contactsMail">
    <el-input v-model="lyFrom.contactsMail"></el-input>
  </el-form-item></el-col>
            </el-row>

  <el-form-item label="请您留言" prop="problemContent">
    <el-input type="textarea" v-model="lyFrom.problemContent"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary" @click="submitForm('lyFrom')">提交</el-button>
    <el-button @click="resetForm('lyFrom')">重置</el-button>
  </el-form-item>
</el-form>
        </div>
      </div>
    </div>

</template>

<script>
import { problemAdd } from '@/api/home'
export default {
  name: 'jdfw',
  data () {
    return {
      lyFrom: {
        contactsName: '',
        contactsMobile: '',
        contactsMail: '',
        problemContent: ''
      },
      rules: {
        contactsName: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' },
          { min: 1, max: 15, message: '长度 1 到 15 个字符', trigger: 'blur' }
        ],
        contactsMobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        contactsMail: [
          { required: true, message: '请选择联系人邮箱', trigger: 'blur' }
        ],
        problemContent: [
          { required: true, message: '请描述您的问题', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          problemAdd(this.lyFrom).then(response => {
            console.log(response)
            if (response.result === 1) {
              this.$message({
                message: '问题已提交，请等待回复', type: 'success'
              })
              this.$refs[formName].resetFields()
            } else {
              this.$message({
                message: '增加失败', type: 'warning'
              })
            }
            this.loading = false
          }).catch(() => {
            this.loading = false
            this.$message({
              message: '提交失败', type: 'warning'
            })
          })
        } else {
          return false
        }
      })
    },
    resetForm (formName) { this.$refs[formName].resetFields() }
  }
}
</script>
<style>
    .jdfw{background: url(../../assets/img/jdvwbackground.png) no-repeat center;background-size:100% 100%;
    min-height: 600px;padding-bottom: 50px}
  .el-main{
    padding: 0px !important;
  }
  .el-form-item__label{
    color: #ffffff;
  }
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/computer/jdfw.vue